import { render, staticRenderFns } from "./TeleMarketData.vue?vue&type=template&id=e87e72f0&scoped=true"
import script from "./TeleMarketData.vue?vue&type=script&lang=js"
export * from "./TeleMarketData.vue?vue&type=script&lang=js"
import style0 from "./TeleMarketData.vue?vue&type=style&index=0&id=e87e72f0&prod&lang=less&scoped=true"
import style1 from "./TeleMarketData.vue?vue&type=style&index=1&id=e87e72f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87e72f0",
  null
  
)

export default component.exports